import React from "react"
import Breadcrumbs from "../../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import RoomRentersTable from "./RoomRentersTable"


export default function RoomRentersList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Room Renters")} />
        <RoomRentersTable />
      </div>
    </div>
  )
}
